import React, { Component } from "react";
import "@ant-design/compatible/assets/index.css";
import { Form, Select, Button, Spin, DatePicker } from "antd";
import moment from "moment";
import fetchHandler from "@/fetch/fetchHandler";
import PropTypes from "prop-types";
import monthPickerHoc from "@/hoc/form/monthPickerHoc";
import { getHPCLog, getFirmwareList, stubCmdFirmware } from "@/fetch/fetchApi";

const defaultDate = moment();
const { RangePicker } = DatePicker;
@monthPickerHoc
class downHPCStubLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gridData: [],
      rangeTime:[],
      spinning: false,
      exportMes: "导出",
      option: [
        {
          value:'DiagnosticsLog',
          text:'诊断日志'
        },
        {
          value:'SecurityLog',
          text:'安全日志'
        }
      ],
      primaryState: true,
      seconds: 11,
      btnLoading: false,
    };
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
    this.query = {
      month: defaultDate.format("YYYY-MM"),
      stubId: this.props.stubIdData,
      page: 1,
    };
    this.interval = null;
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
  }

  onFinish = (values) => {
    console.log('Success:', values);
    this.setState({
      spinning: true
    });
    console.info(values.rangeTime[0].valueOf())
    fetchHandler(getHPCLog, {
      stubId: this.props.stubId,
      oldestTimestamp: values.rangeTime[0].valueOf(),
      latestTimestamp: values.rangeTime[1].valueOf(),
      // logType: values.frameWork,
      logType: 'DiagnosticsLog',
    }).then((res) => {
      if (res && res.code === "success") {
        this.props.downHPCStubLogFunc(res.data);
      } else {
        this.props.errorHandler();
      }
      this.setState({
        spinning: false,
      });
    });
  };
  
  onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };


  init() {}

  setFrameWork = (value) => {
    const frameInfo = value.split("-");
    this.setState({
      frameWork: frameInfo[0],
      primaryState: false,
      smallVersion: frameInfo.length === 2 ? frameInfo[1] : null,
    });
  };


  render() {
    return (
      <Form className="login-form update-frame-work-modal"
      initialValues={{ frameWork: 'DiagnosticsLog', rangeTime: [moment(new Date()).subtract(7, "d"), moment(new Date())] }}
      onFinish={this.onFinish}
      onFinishFailed={this.onFinishFailed}
      >
        <Spin spinning={this.state.spinning}>
          <Form.Item
            name="rangeTime"
            label="时间:"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 15 }}
            rules={[{ required: true, message: '请选择日期范围' }, { validator: (rule, value, callback, item) =>{
              if (value && value[0]) {
                const starDate = moment(value[0]);
                const endDate = moment(value[1]);
                const diffDate = endDate.diff(starDate, "days") + 1;
                
                if (diffDate > 30) {
                  callback(
                    `最多选择30天`,
                  );
                } else {
                  callback();
                }
              } else {
                callback();
              }
              
            } }]}>
            <RangePicker showTime format="YYYY-MM-DD HH:mm:ss" />
          </Form.Item>
          {/* <Form.Item
            name="frameWork"
            label="日志类型:"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 15 }}
            rules={[{ required: true, message: '请选择日志类型' }]}
            >
            <Select placeholder="请选择">
              {this.state.option.map((item) => {
                return <option value={item.value}> {item.text}</option>;
              })}
            </Select>
          </Form.Item>*/}
          <Form.Item wrapperCol={{ span: 15, offset: 5 }} style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="submit"
              >
              确定
            </Button>
            <Button type="default" onClick={this.props.onCancel} style={{ marginLeft: "20px" }}>
              取消
            </Button>
          </Form.Item> 
          </Spin>
      </Form>
    );
  }
}

export default downHPCStubLog;



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/downHPCStubLog.js